import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watchEffect } from 'vue';
import { defaultRealms } from '@/foundations/helpers/defaultRealms';

type Emits = {
  (e: 'change', select: string[]): void;
};
type Props = {
  rules: { notEmptyRule: (v: string[]) => boolean };
  combinedRealms: string[];
  showLabel?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MarketSelect',
  props: {
    rules: null,
    combinedRealms: null,
    showLabel: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', select: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  rules: { notEmptyRule: (v: string[]) => boolean };
  combinedRealms: string[];
  showLabel?: boolean;
}




const { combinedRealms } = toRefs(props);

const availableMarkets = defaultRealms;
const modelValue = ref<string[]>(combinedRealms.value);

watchEffect(() => {
  modelValue.value = combinedRealms.value;
});

return { __sfc: true,emit, props, combinedRealms, availableMarkets, modelValue }
}

})